<template>
	<span>{{ currentCredits }}</span>
</template>

<script>
export default {
  mounted() {

    var vm = this;
    vm.getCurrentCredits();
    setInterval(function(){ vm.getCurrentCredits();}, 3000);

  },
  props: [
            'credits',
  ],
  data() {
    return {
		  currentCredits: this.credits
    };
  },
  methods: {
    getCurrentCredits: function() {

      var vm = this;

      axios.get('/company/credits').then(response => {

        vm.currentCredits = response.data;

      }).catch(function(error){  });

    }
   }
  }
</script>



	        